module.exports = __webpack_public_path__ + "static/index-slider-01-bbe006ff66099f97429b8b49ec450c73.jpg";